export default __webpack_public_path__ + "app/images/1ca1cc8326d370a0bdd1389d63e61000.png";